function isMobileDevice() {
    return window.matchMedia("only screen and (max-width: 768px)").matches;
}

function checkNoteField() {
    if($('#CartDrawer-Note').val()?.trim() == "on") {
        $('#CartDrawer-Note').val('');
    }
    if($('#Cart-note').val()?.trim() == "on") {
        $('#Cart-note').val('');
    }
}

$(document).ready(function () {
    if (isMobileDevice()) {
        $('.accordion-header').click(function () {
            $(this).parent().toggleClass('active');
            $(this).next('.accordion-content').slideToggle();
        });
    }

    checkNoteField();
    
    $(document).on('keyup', '#CartDrawer-Note', function() {
        var value = $(this).val();
        console.log("change event: ", value);
        $("#cartFormNote").val(value);
    });
   
    $(document).on('change', '.quantity__input', function() {
        var selectedQty = $(this).val();
        var qtyInCart = $("product-info quantity-input").attr("data-in-cart");
        var qtyMax = $("product-info quantity-input").attr("data-max-qty");
        var availableQty = parseInt(qtyMax) - parseInt(qtyInCart);
        if (selectedQty > availableQty) {
            $("product-form.product-form").find("button.product-form__submit").attr("disabled", "disabled");
            $("#qtyError .product-form__qty-error-message").html(`Sorry, There are only ${qtyMax} number of products available in stock right now.`);
            $("#qtyError").removeClass("hidden");
        } else {
            $("product-form.product-form").find("button.product-form__submit").removeAttr("disabled");
            $("#qtyError").addClass("hidden");
        }
    });

    $(document).on('click', '.shopify-payment-button', function() {
        console.log("shopify-payment-button");
        var form = $(this).closest('form[data-type="add-to-cart-form"]');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: form.serialize(),
            dataType: 'json',
            success: function () {
                document.location.href = '/cart/checkout';
            },
            error: function () {
                console.log("can't go to checkout page");
                $('.shopify-payment-button').closest(".product-form__buttons").find("button[type='submit'").click();
                // Do something on error (e.g. show an error message)
            }
        });
    })
    $(document).on('change', '.ath-check', function() {
        checkNoteField();
        var target = $("#cartAtl");
        if(this.checked) {
            target.attr("value", "No"); 
            $('.ath-check').prop('checked', true);
            $("#cartAtl1")?.attr("value", "No");
        }else {
            target.attr("value", "Yes"); 
            $('.ath-check').prop('checked', false); 
            $("#cartAtl1")?.attr("value", "Yes");
        }
    })
});